import { Stack, Box } from "@mui/material";
import { HeaderInfo } from "../../types";
import LaunchSharpIcon from "@mui/icons-material/LaunchSharp"; 
import { useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";


const SearchResultTableHeader = ({  
  header,
  onViewAllHandler,
  handleClose,
}: {
  header: HeaderInfo;
  onViewAllHandler: (header: HeaderInfo) => void;
  handleClose?: () => void;
}) => {
  const headerName = header.key;
  console.log(headerName,"hrrrrrrrrrrrrrr");
  
  const theme = useTheme();
    const navigate = useNavigate();

  const isDarkMode = theme.palette.mode === "dark";
  return (
    <Stack direction="row" display="flex" alignItems="center">
      <Stack direction="row" display="flex" alignItems="center" gap={1}>
        <Box component="span">
          {headerName === "Assets" && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <g clipPath="url(#clip0_3448_7787)">
                <path
                  d="M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V20C8 20.55 8.45 21 9 21H15C15.55 21 16 20.55 16 20V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.89 22.1 3 21 3ZM20 17H4C3.45 17 3 16.55 3 16V6C3 5.45 3.45 5 4 5H20C20.55 5 21 5.45 21 6V16C21 16.55 20.55 17 20 17Z"
                  fill="#3A2ADA"
                />
              </g>
              <defs>
                <clipPath id="clip0_3448_7787">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          )}
          {headerName === "Controls" && (
            <svg
              width="20"
              height="18"
              viewBox="0 0 20 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.6523 7.27746C18.9581 7.29785 19.2027 7.52208 19.2639 7.82786C19.325 8.21518 19.3862 8.60249 19.3862 9.01019C19.3862 9.41789 19.3454 9.80521 19.2843 10.1925C19.2231 10.4983 18.9785 10.7225 18.6727 10.7429L17.8369 10.8041L17.8369 10.8041C17.7554 11.0487 17.6738 11.2933 17.5515 11.5176L18.1019 12.1699C18.3058 12.3941 18.3262 12.7407 18.1427 12.9853C17.6738 13.6172 17.1234 14.188 16.4711 14.6365C16.2265 14.8199 15.88 14.7995 15.6557 14.5957L15.0034 14.0453C14.9472 14.0687 14.8921 14.0921 14.8376 14.1153C14.6547 14.193 14.4784 14.2679 14.2899 14.3307L14.2288 15.1665C14.2084 15.4723 13.9841 15.7169 13.6784 15.778C13.5968 15.7882 13.5102 15.7984 13.4235 15.8086C13.3369 15.8188 13.2503 15.829 13.1687 15.8392V17.3273C13.1687 17.6942 12.863 18 12.496 18H0.672707C0.305776 18 0 17.6942 0 17.3273V3.66931C0 3.48584 0.0815402 3.32276 0.203851 3.20045L3.20045 0.203851C3.32276 0.0611552 3.48584 0 3.66931 0H10.3556C10.7225 0 11.0283 0.305776 11.0283 0.672707C11.0283 1.03964 10.7225 1.34541 10.3556 1.34541H4.32163V3.66931C4.32163 4.03624 4.01585 4.34202 3.64892 4.34202H1.32503V16.675H11.8233V15.8596C11.7114 15.8596 11.5899 15.8404 11.4719 15.8217C11.418 15.8132 11.3649 15.8048 11.3137 15.7984C11.0079 15.7373 10.7837 15.4926 10.7633 15.1869L10.7022 14.3511L10.7021 14.3511C10.4575 14.2695 10.2129 14.188 9.98868 14.0657L9.33635 14.6161C9.11212 14.8199 8.76557 14.8403 8.52095 14.6569C7.88901 14.2084 7.31823 13.658 6.86976 13.0057C6.6863 12.761 6.70668 12.4145 6.91053 12.1903L7.46093 11.5379C7.43752 11.4818 7.41411 11.4267 7.39095 11.3721C7.31326 11.1892 7.23835 11.0129 7.17554 10.8245L6.33975 10.7633C6.03397 10.7429 5.78935 10.5187 5.7282 10.2129C5.66704 9.8256 5.62627 9.43828 5.62627 9.03058C5.62627 8.62288 5.66704 8.23556 5.7282 7.84825C5.78935 7.54247 6.03397 7.31823 6.33975 7.29785L7.17554 7.23669L7.17554 7.23668C7.25708 6.99207 7.33862 6.74745 7.46093 6.52322L6.91053 5.87089C6.70668 5.64666 6.6863 5.30011 6.86976 5.05549C7.33862 4.40317 7.88901 3.83239 8.54134 3.38392C8.78596 3.20045 9.1325 3.22084 9.35674 3.42469L9.98868 3.97509C10.0449 3.95168 10.1 3.92827 10.1545 3.9051C10.3374 3.82742 10.5137 3.75251 10.7022 3.68969L10.7633 2.85391C10.7837 2.54813 11.0079 2.30351 11.3137 2.24236C12.0883 2.09966 12.8834 2.09966 13.658 2.24236C13.9638 2.30351 14.188 2.54813 14.2084 2.85391L14.2695 3.68969C14.5142 3.77123 14.7588 3.85277 14.983 3.97509L15.6557 3.42469C15.88 3.22084 16.2265 3.20045 16.4711 3.38392C17.1031 3.83239 17.6738 4.38279 18.1223 5.03511C18.3058 5.27973 18.2854 5.62627 18.0815 5.85051L17.5311 6.50283C17.5546 6.55902 17.578 6.61413 17.6011 6.66866C17.6788 6.85154 17.7537 7.02788 17.8165 7.21631L18.6523 7.27746ZM17.2458 9.51982L18.0204 9.45866C18.0204 9.3744 18.0258 9.29558 18.0311 9.21939C18.036 9.14813 18.0408 9.07916 18.0408 9.01019C18.0408 8.84711 18.0408 8.70442 18.0204 8.56172L17.2458 8.50057C16.9604 8.48018 16.7157 8.27633 16.6546 7.99094C16.5527 7.56285 16.3692 7.15515 16.145 6.76784C16.0023 6.52322 16.0226 6.21744 16.2061 5.99321L16.6954 5.36127C16.5119 5.15742 16.308 4.93318 16.0838 4.74972L15.4926 5.25934C15.2888 5.44281 14.9626 5.46319 14.718 5.3205C14.3307 5.07588 13.923 4.9128 13.4949 4.81087C13.2095 4.74972 13.0057 4.5051 12.9853 4.21971L12.9241 3.44507C12.6387 3.42469 12.333 3.42469 12.0476 3.44507L11.9864 4.21971C11.966 4.5051 11.7622 4.74972 11.4768 4.81087C11.0487 4.9128 10.641 5.09626 10.2537 5.3205C10.0091 5.46319 9.70328 5.44281 9.47905 5.25934L8.90827 4.7701C8.70442 4.95357 8.48018 5.15742 8.29672 5.38165L8.80634 5.97282C8.98981 6.17667 9.01019 6.50283 8.8675 6.74745C8.62288 7.13477 8.4598 7.54247 8.35787 7.97056C8.29672 8.25595 8.05209 8.4598 7.7667 8.48018L6.99207 8.54134C6.97169 8.70442 6.97169 8.82673 6.97169 8.98981C6.97169 9.15289 6.97169 9.29558 6.99207 9.43828L7.7667 9.49943C8.05209 9.51982 8.29672 9.72367 8.35787 10.0091C8.4598 10.4371 8.64326 10.8448 8.8675 11.2322C9.01019 11.4768 8.98981 11.7826 8.80634 12.0068L8.29672 12.598C8.48018 12.8018 8.68403 13.026 8.90827 13.2095L9.49943 12.7203C9.70328 12.5368 10.0294 12.5164 10.2741 12.6591C10.6614 12.9037 11.0691 13.0668 11.4972 13.1687C11.7826 13.2299 11.9864 13.4745 12.0068 13.7599L12.068 14.5345C12.3533 14.5549 12.6591 14.5549 12.9445 14.5345L13.0057 13.7599C13.026 13.4745 13.2299 13.2299 13.5153 13.1687C13.9434 13.0668 14.3511 12.8834 14.7384 12.6591C14.983 12.5164 15.2888 12.5368 15.513 12.7203L16.1042 13.2299C16.308 13.0464 16.5323 12.8426 16.7157 12.6183L16.2061 12.0272C16.0226 11.8233 16.0023 11.4972 16.145 11.2525C16.3896 10.8652 16.5527 10.4575 16.6546 10.0294C16.7157 9.74405 16.9604 9.54021 17.2458 9.51982ZM10.335 9.00888C10.335 7.82655 11.3135 6.84807 12.4958 6.84807C13.6782 6.84807 14.6566 7.82655 14.6566 9.00888C14.6566 10.1912 13.6782 11.1697 12.4958 11.1697C11.3135 11.1697 10.335 10.1912 10.335 9.00888ZM11.66 9.00888C11.66 9.47774 12.0474 9.84467 12.4958 9.84467C12.9443 9.84467 13.3316 9.47774 13.3316 9.00888C13.3316 8.54003 12.9443 8.1731 12.4958 8.1731C12.027 8.1731 11.66 8.54003 11.66 9.00888Z"
                fill="#3A2ADA"
              />
            </svg>
          )}

          {headerName === "Scans" && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 3H7V1H2V6H4V3ZM22 1V6H20V3H17V1H22ZM4 21H7V23H2V18H4V21ZM20 21V18H22V23H17V21H20ZM13.336 4C13.76 4 14.168 4.168 14.472 4.472L18.328 8.336C18.632 8.632 18.8 9.04 18.8 9.464V11H22V14H18.8V18.4C18.8 19.28 18.08 20 17.2 20H7.592C6.712 20 6 19.28 6 18.4V14H2V11H6V5.6C6 4.72 6.72 4 7.6 4H13.336ZM10 16.8H14.8C15.24 16.8 15.6 16.44 15.6 16C15.6 15.56 15.24 15.2 14.8 15.2H10C9.56 15.2 9.2 15.56 9.2 16C9.2 16.44 9.56 16.8 10 16.8ZM13.2 5.2V8.8C13.2 9.24 13.56 9.6 14 9.6H17.6L13.2 5.2ZM10 11.7C9.55818 11.7 9.20001 12.0582 9.20001 12.5C9.20001 12.9418 9.55819 13.3 10 13.3H14.8C15.2418 13.3 15.6 12.9418 15.6 12.5C15.6 12.0582 15.2418 11.7 14.8 11.7H10Z"
                fill="#3A2ADA"
              />
            </svg>
          )}
          {headerName === "Users" && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <g clipPath="url(#clip0_3448_7776)">
                <path
                  d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
                  fill="#3A2ADA"
                />
              </g>
              <defs>
                <clipPath id="clip0_3448_7776">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          )}

          {headerName === "Roles" && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <g clipPath="url(#clip0_3448_7779)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 14.06L9 17L12 20H3V18C3 15.34 8.33 14 11 14C11.32 14 11.61 14.02 12 14.06ZM15 8C15 10.21 13.21 12 11 12C8.79 12 7 10.21 7 8C7 5.79 8.79 4 11 4C13.21 4 15 5.79 15 8ZM12 17L15.47 20.5L22 13.91L20.6 12.5L15.47 17.67L13.4 15.59L12 17Z"
                  fill="#3A2ADA"
                />
              </g>
              <defs>
                <clipPath id="clip0_3448_7779">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          )}
        </Box>
        <h5
        // style={{
        //   marginTop: "-3px",
        //   borderRight: "1px solid #D9D9D9",
        //   paddingRight: "10px",
        // }}
        >
          {headerName}
        </h5>
      </Stack>
      <button
        disabled={header?.highlight}
        className="view-btn"
        onClick={() => onViewAllHandler(header)}
      >
        View All
      </button>
      <LaunchSharpIcon
                  sx={{
                    color: isDarkMode ? "white" : "black",
                    cursor: "pointer",
                    fontSize: "17px",
                  }}
                  onClick={() => {
                    console.log("GLOBAL SEARCH - Clicking 'View All' Redirection Icon for:", headerName);
                    if(headerName==="Cve"){navigate("/on-premises/cve");}
                  else if(headerName==="Assets"){navigate("/on-premises/assets")}
                  else if(headerName==="Roles"){navigate("/organization/roles")}
                  else if(headerName==="Scans"){navigate("/on-premises/scans")}
                  else if(headerName==="Users"){navigate("/organization/user-management")}
                  else if(headerName==="Controls"){navigate("/on-premises/security-posture")}
                  else if(headerName==="Benchmarks"){navigate("/on-premises/security-posture")}
                  else if(headerName==="Resources"){navigate("/cloud/cloud-resources", { state: { module: "cloud" } })}
                  else if(headerName==="Cloud-Controls"){navigate("/cloud/security-posture")}
                  else{navigate("")}

                    if (handleClose) {
                      handleClose();
                    }
                  }}
                />
    </Stack>
  );
};

export default SearchResultTableHeader;
